export const DISALLOWED_COOKIE_PREFIXES = ['chayns_at', 'chayns_rt', 'chayns_guarded'];
